export default __webpack_public_path__ + "static/media/warning--texts--g1.f8515b5d.png";